<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Preços Produtos
            </v-card-title>

            <!-- Filtros: v-expansion-panels -->
            <v-card-text>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-title>Filtros</v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-row dense>
                                <!-- datas principais -->
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filters.dtini" label="Data Início (DD/MM/YYYY)"
                                        placeholder="DD/MM/YYYY" maxlength="10"
                                        @update:modelValue="val => filters.dtini = val.replace(/[^0-9]/g, '').slice(0, 8).replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3')" />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filters.dtfim" label="Data Fim (DD/MM/YYYY)"
                                        placeholder="DD/MM/YYYY" maxlength="10"
                                        @update:modelValue="val => filters.dtfim = val.replace(/[^0-9]/g, '').slice(0, 8).replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3')" />
                                </v-col>

                                <!-- datas cadastro revenda -->
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filters.dtinic" label="Cadastro Revenda Início" />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filters.dtfimc" label="Cadastro Revenda Fim" />
                                </v-col>

                                <!-- localização / status -->
                                <v-col cols="12" md="3">
                                    <v-select :items="estados" v-model="filters.estado" label="Estado" dense
                                        clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filters.cidade" label="Cidade" dense clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select item-value="value" item-title="label" :items="filterDefault"
                                        v-model="filters.statusrevendedor" label="Status Revendedor" dense clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select item-value="value" item-title="label" :items="filterDefault"
                                        v-model="filters.statusrevenda" label="Status Revenda" dense clearable />
                                </v-col>

                                <!-- outros filtros -->
                                <v-col cols="12" md="3">
                                    <v-select v-model="filters.dtvalidade" label="Ativo tmkt" dense item-value="value"
                                        item-title="label" :items="filterDefault" clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select :items="marcas" v-model="filters.marca" label="Marca" item-value="value"
                                        item-title="label" dense clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select :items="tiposProduto" v-model="filters.tipoproduto" label="Tipo Produto"
                                        item-value="value" item-title="label" dense clearable />
                                </v-col>

                                <!-- pesquisa livre -->
                                <v-col cols="12" md="3">
                                    <v-select :items="camposPesquisa" v-model="filters.nome_campo_filtro"
                                        label="Campo pesquisa" dense clearable />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="filters.pesquisar" label="Pesquisar" clearable />
                                </v-col>

                                <v-col cols="12" md="3" class="d-flex align-center">
                                    <v-btn :loading="loading" color="primary" @click="onCarregar">Carregar</v-btn>


                                    <v-btn text @click="clearFilters" class="ml-2">Limpar</v-btn>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-text>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>

            <!-- Tabela -->
            <v-card-text>
                <v-alert v-if="error" type="error" variant="tonal" closable class="mb-4" @click:close="error = ''">
                    {{ error }}
                </v-alert>

                <v-data-table :headers="headers" :items="items" :server-items-length="totalItems" :loading="loading"
                    :sort-by="pagination.sortBy" :sort-desc="pagination.sortDesc"
                    @update:items-per-page="onItemsPerPageChange" @update:sort-by="onSortBy"
                    @update:sort-desc="onSortDesc" class="elevation-1">
                    <template #item.preco_novo="{ item }">
                        <span :class="item.preco_novo !== item.preco_antigo ? 'text--primary font-weight-bold' : ''">
                            {{ formatCurrency(item.preco_novo) }}
                        </span>
                    </template>

                    <template #item.acoes="{ item }">
                        <v-menu offset-y>
                            <template #activator="{ props }">
                                <v-btn icon v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="verHistorico(item)">
                                    <v-list-item-title>Ver Histórico</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="toggleAtivo(item)">
                                    <v-list-item-title>{{ item.ativo ? 'Desativar' : 'Ativar' }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="excluir(item)">
                                    <v-list-item-title>Excluir</v-list-item-title>
                                </v-list-item>
                                <!-- <v-list-item @click="exportRow(item)">
                                    <v-list-item-title>Exportar</v-list-item-title>
                                </v-list-item> -->
                            </v-list>
                        </v-menu>
                    </template>

                    <!-- slot bottom com paginação e seletor de page size -->
                    <template #bottom>
                        <v-row class="pa-4" align="center">
                            <v-col cols="12" md="4">
                                <v-pagination :total-visible="5" :model-value="pagination.page" :length="pageCount"
                                    @update:model-value="onPageChange" />
                            </v-col>
                            <v-col cols="12" md="4" class="d-flex align-center">
                                <v-select :items="lengthMenu" v-model="pagination.itemsPerPage" label="Itens por página"
                                    dense hide-details style="max-width:120px" />
                                <div class="mx-4">Registros: {{ totalItems }}</div>
                            </v-col>
                            <!-- espaço para botões globais como exportar -->
                            <!-- <v-col cols="12" md="4" class="text-right">
                                <v-btn icon @click="exportAll"><v-icon>mdi-export</v-icon></v-btn>
                            </v-col> -->
                        </v-row>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { PRICE_ROTAS, REVENDA_ROTAS } from '@/utils/apiRoutes'
import { useApi } from '@/utils/axios'

/* estados do componente */
const loading = ref(false)
const error = ref(null)
const items = ref([])
const totalItems = ref(0)

/* filtros iniciais */
const filters = reactive({
    dtini: '',
    dtfim: '',
    dtinic: '',
    dtfimc: '',
    estado: null,
    cidade: '',
    statusrevendedor: null,
    statusrevenda: null,
    dtvalidade: null,
    marca: null,
    tipoproduto: null,
    nome_campo_filtro: null,
    pesquisar: ''
})

/* paginação / ordenação */
const pagination = reactive({
    page: 1,
    itemsPerPage: 10,
    // Vuetify espera arrays para sort-by / sort-desc internamente.
    // Inicializar como arrays evita 'Cannot read properties of null (reading "find")'.
    sortBy: [],
    sortDesc: []
})

const lengthMenu = [10, 25, 50, 100]
const headers = [
    { title: 'R/Social', key: 'razaosocial', value: 'razaosocial', sortable: true },
    { title: 'N/Fantasia', key: 'nomefantasia', value: 'nomefantasia', sortable: true },
    { title: 'Boleto', key: 'boleto_aberto', value: 'boleto_aberto' },
    { title: 'At/Rev', key: 'revendedor_ativo', value: 'revendedor_ativo' },
    { title: 'At/Rva', key: 'revenda_ativa', value: 'revenda_ativa' },
    { title: 'Uf', key: 'estado', value: 'estado' },
    { title: 'Cidade', key: 'cidade', value: 'cidade' },
    { title: 'Tipo', key: 'tipo', value: 'tipo' },
    { title: 'Marca', key: 'marca', value: 'marca' },
    { title: 'Dinheiro', key: 'valor', value: 'valor', sortable: true },
    { title: 'Cartão', key: 'valorportaria', value: 'valorportaria' },
    { title: 'T/Ped', key: 'total_pedidos', value: 'total_pedidos' },
    { title: 'Ped/Entre', key: 'total_entregue', value: 'total_entregue' },
    { title: 'Ped/Cl', key: 'total_rejeitados', value: 'total_rejeitados' },
    { title: 'Tx %x', key: 'txval', value: 'txval' },
]

const filterDefault = [{ label: 'Ativado', value: 1 }, { label: 'Desativado', value: 0 }]
const estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
]
const marcas = ref([]) /* {label:string;value:}[] */
const tiposProduto = ref([]) /* {label:string;value:}[] */
const camposPesquisa = ['nome', 'responsavel', 'razaosocial', 'nomefantasia', 'celular/telefone1/telefone2', 'email', 'gestor']

/* computed para page count */
const pageCount = ref(0);

/* helper simples para formatar moeda */
function formatCurrency(v) {
    if (v == null) return ''
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v)
}

/* Validação de datas DD/MM/YYYY: retorna timestamp ou null */
function parseDateDMY(s) {
    if (!s) return null
    const parts = s.split('/')
    if (parts.length !== 3) return null
    const d = parseInt(parts[0], 10)
    const m = parseInt(parts[1], 10) - 1
    const y = parseInt(parts[2], 10)
    const dt = new Date(y, m, d)
    if (dt && dt.getDate() === d && dt.getMonth() === m && dt.getFullYear() === y) return dt.getTime()
    return null
}

function clearFilters() {
    filters.dtini = ''
    filters.dtfim = ''
    filters.dtinic = ''
    filters.dtfimc = ''
    filters.estado = null
    filters.cidade = ''
    filters.statusrevendedor = null
    filters.statusrevenda = null
    filters.dtvalidade = null
    filters.marca = null
    filters.tipoproduto = null
    filters.nome_campo_filtro = null
    filters.pesquisar = ''
}

/* Função que carrega os dados (substituir endpoint conforme backend) */
async function loadData() {
    // valida datas: dtfim >= dtini

    loading.value = true
    try {
        const params = {
            ...filters,
            start: pagination.page,
            pagesize: pagination.itemsPerPage,
            ordem: pagination.sortBy,
            sort_desc: pagination.sortDesc ? 1 : 0,
            dtini: filters.dtini,
            dtfim: filters.dtfim,
        }

        // endpoint ilustrativo — ajustar para o real (utils/apiRoutes)
        const api = useApi(PRICE_ROTAS.LIST_PRECOS_PRODUTOS)
        const resp = await api.fetch({ params })

        const data = resp.data || {}
        items.value = data || []
        totalItems.value = resp.total || (items.value.length)
        pageCount.value = resp.pages || Math.ceil(totalItems.value / pagination.itemsPerPage)
    } catch (err) {
        console.error('Erro ao carregar dados', err)
        error.value = err.response?.data?.message || err.message || 'Erro ao carregar dados';
    } finally {
        loading.value = false
    }
}

/* handlers de paginação / sorting */
function onPageChange(newPage) {
    console.log('Page change:', newPage)
    pagination.page = newPage
    loadData()
}
function onItemsPerPageChange(newSize) {
    pagination.itemsPerPage = newSize
    pagination.page = 1
    loadData()
}
// newSort is typically an array (Vuetify emits array for multi-sort)
function onSortBy(newSort) {
    pagination.sortBy = Array.isArray(newSort) ? newSort : (newSort ? [newSort] : [])
    loadData()
}
// newDesc may be array/boolean depending on Vuetify; normalizar para array
function onSortDesc(newDesc) {
    if (Array.isArray(newDesc)) {
        pagination.sortDesc = newDesc
    } else {
        // single boolean -> transform to array aligned with sortBy length
        pagination.sortDesc = pagination.sortBy.map(() => !!newDesc)
    }
    loadData()
}

/* Ações de linha (stubs) */
function verHistorico(item) {
    // abrir modal com detail (implementar modal)
    console.log('Ver histórico', item)
}
function toggleAtivo(item) {
    // confirmar e chamar endpoint; depois recarregar
    console.log('Toggle ativo', item)
}
function excluir(item) {
    // confirmar e chamar endpoint; depois recarregar
    console.log('Excluir', item)
}
function exportRow(item) {
    // exportar linha
    console.log('Export', item)
}
function exportAll() {
    console.log('Export all with current filters', filters)
}

/* evento do botão Carregar */
function onCarregar() {
    pagination.page = 1
    loadData()
}

function loadMarcasAndTipo() {
    // exemplo de chamada para carregar opções de marca (ajustar endpoint)
    const apiFabricantes = useApi(REVENDA_ROTAS.BUSCAR_FABRICANTES)

    apiFabricantes.fetch()
        .then(resp => {
            const data = resp.data || []
            marcas.value = data.map(m => ({ label: m.nome, value: m.id }))
        })
        .catch(err => {
            error.value = 'Erro ao carregar marcas'
        })

    const apiTipos = useApi(REVENDA_ROTAS.BUSCAR_TIPO_PRODUTOS)

    apiTipos.fetch()
        .then(resp => {
            const data = resp.data || []
            tiposProduto.value = data.map(t => ({ label: t.tipo, value: t.id }))
        })
        .catch(err => {
            error.value = 'Erro ao carregar tipos de produto'
        })
}

onMounted(() => {
    loadMarcasAndTipo()
})
</script>

<style scoped>
/* ...existing styles... */
</style>
